
import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface HebrewLoanTypeCardProps {
  title: string;
  description: string;
  detailText: string;
  icon: LucideIcon;
  linkPath: string;
}

export const HebrewLoanTypeCard = ({ title, description, detailText, icon: Icon, linkPath }: HebrewLoanTypeCardProps) => {
  return (
    <Card className="bg-white hover:shadow-lg transition-shadow">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-xl text-blue-700">{title}</CardTitle>
          <div className="bg-blue-100 p-2 rounded-full transition-transform duration-300 hover:scale-110">
            <Icon className="text-blue-600 h-6 w-6" />
          </div>
        </div>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-gray-700 mb-4 h-16">
          {detailText}
        </p>
        <Link 
          to={linkPath} 
          className="text-blue-600 font-medium hover:underline inline-flex items-center group"
          aria-label={`קרא עוד על הלוואה: ${title} - ${description}`}
          title={`ראה פרטים נוספים על הלוואה: ${title}`}
        >
          קרא עוד על אפשרויות {title}
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 group-hover:mr-2 transition-all rotate-180" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </Link>
      </CardContent>
    </Card>
  );
};
